export class Constants {
  public static readonly PERCENTAGE_FIXED_FRACTION_DIGITS: number = 9;
}
